import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64f01858"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "app__title mt-0" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "course-subtitle black__base__color" }
const _hoisted_6 = { class: "event-entry black__base__color" }
const _hoisted_7 = { class: "course-name black__base__color" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons date-icon" }, " date_range ", -1))
const _hoisted_9 = { class: "course-dates-title" }
const _hoisted_10 = { class: "course-dates-title" }
const _hoisted_11 = {
  key: 1,
  class: "certificate-legend"
}
const _hoisted_12 = { class: "courses-title black__base__color" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "speaker-name primary__color__light"
}
const _hoisted_15 = { class: "course-name black__base__color" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons date-icon" }, " date_range ", -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 1,
  class: "certificate-legend"
}
const _hoisted_20 = {
  key: 0,
  class: "container-phone"
}
const _hoisted_21 = { class: "message-gp" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icon glyphicon" }, "perm_phone_msg", -1))
const _hoisted_23 = { class: "demo-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_Surveys = _resolveComponent("Surveys")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "app__header__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("program.events")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("program.courses.courses")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { class: "card-courses" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "profile-image",
            src: _ctx.filterProfileImage(_ctx.participantData.profileImage),
            alt: "profile-image"
          }, null, 8, _hoisted_4),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("program.courses.coursesAndCertificates")), 1)
        ]),
        _createVNode(_component_el_row, { class: "row-courses" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              xs: 24,
              sm: 24,
              md: 24,
              lg: 24,
              xl: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    (!_ctx.statusPaid && _ctx.isAvailableEventCertificate)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 0,
                          span: 24
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("program.courses.eventEntry")), 1),
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.eventData.name), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  class: "title-dates",
                                  span: 24
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_8,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t("program.courses.eventDate")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  class: "course-info",
                                  span: 24
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", null, [
                                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("program.courses.startDate")) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.filterDate(_ctx.eventData.startDate)), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("program.courses.endDate")) + ":", 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.filterDate(_ctx.eventData.endDate)), 1)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  class: "course-info",
                                  span: 24
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.filterTime(_ctx.eventData.startDate)) + " - " + _toDisplayString(_ctx.filterTime(_ctx.eventData.endDate)), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  span: 24,
                                  class: "text-center"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.validDownloadCertificated(_ctx.eventData.endDate))
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 0,
                                          class: "certificate-btn primary__color__button btn-size",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDownloadCertificate()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("program.courses.downloadCertificate")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("program.courses.certificateNotAvailable")), 1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_divider),
                            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("program.courses.courses")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseData, (course) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        span: 24,
                        key: course.id
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 1,
                                style: {"margin-right":"45px"}
                              }, {
                                default: _withCtx(() => [
                                  (course.speaker)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "speaker-image",
                                        src: _ctx.filterProfileImage(course.speaker.picture)
                                      }, null, 8, _hoisted_13))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, {
                                span: course.speaker ? 16 : 24
                              }, {
                                default: _withCtx(() => [
                                  (course.speaker && course.speaker.speakerName)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(course.speaker.speakerName), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", _hoisted_15, _toDisplayString(course.eventName), 1)
                                ]),
                                _: 2
                              }, 1032, ["span"]),
                              _createVNode(_component_el_col, {
                                class: "title-dates text-center",
                                span: 24
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_16,
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("program.courses.courseDate")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, { class: "text-center" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Calendar, {
                                    "is-expanded": true,
                                    attributes: course.calendarDates
                                  }, null, 8, ["attributes"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, { class: "course-info" }, {
                                default: _withCtx(() => [
                                  (course.price)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t("program.courses.cost")) + ": " + _toDisplayString(course.price), 1))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t("program.courses.freeCourse")), 1))
                                ]),
                                _: 2
                              }, 1024),
                              (course.streamingURL)
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 0,
                                    span: 24,
                                    class: "course-url text-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        class: "meeting-btn btn-size",
                                        onClick: ($event: any) => (_ctx.goTo(course.streamingURL))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("program.courses.streamingURL")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              (_ctx.showSurvey(course))
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 1,
                                    span: 24,
                                    class: "text-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        class: "secondary__color__button evaluate-btn btn-size",
                                        onClick: ($event: any) => (_ctx.openSurvey(course.surveyURL))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("program.courses.evaluate")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_col, {
                                span: 24,
                                class: "text-center"
                              }, {
                                default: _withCtx(() => [
                                  (
                      _ctx.validCourseDownloadCertificated(
                        course.scheduledDates,
                        course.id
                      )
                    )
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        class: "certificate-btn primary__color__button btn-size",
                                        onClick: ($event: any) => (_ctx.onDownloadCertificate(course.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("program.courses.downloadCertificate")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("program.courses.certificateNotAvailable")), 1))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_divider)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.showGeneralPhone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("contactUsMessage")), 1),
              _createVNode(_component_el_row, { class: "text-box" }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.generalPhone), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Surveys)
  ]))
}